import React, { useEffect } from 'react';
import styled from 'styled-components';
import router from 'next/router';
import { Box, Container, Flex } from '@components/layout/Grid';
import { HEADER_HEIGHT } from '@lib/constants';

const MainVideo = styled(Box)``;

type Props = {
  className?: string;
  breadCrumb: JSX.Element;
  headerSection: JSX.Element;
  subHeader: JSX.Element;
  mainVideo: JSX.Element;
  steps(): React.ReactNode | React.ReactNode[];
  //
  banner?: JSX.Element;
  mx?: number | string;
};

const ProgramVideoPlayerLayout = (props: Props) => {
  useEffect(() => {
    const routeChangeComplete = () => {
      setTimeout(() => {
        const container = document.getElementById('MainVideo--Portal');
        if (container) {
          window.scrollTo({
            top: container?.offsetTop - HEADER_HEIGHT,
            behavior: 'smooth',
          });
        }
      }, 1000);
    };

    router.events.on('routeChangeComplete', routeChangeComplete);

    return () => {
      router.events.off('routeChangeComplete', routeChangeComplete);
    };
  }, []);

  return (
    <div className={['layout', props.className].join(' ')}>
      {props.breadCrumb}
      {props.headerSection}
      {props.subHeader}
      <Container flexDirection={'column'} px={[0, 0, 10]} fullWidth>
        {props.banner}
        <Flex mx={['0px', '0px', '-10px']} flexWrap="wrap">
          <MainVideo
            id="MainVideo--Portal"
            width={[1, 1, 1, 2 / 3]}
            mb={['20px', '20px', '0px']}
          >
            {props.mainVideo}
          </MainVideo>
          <Box width={[1, 1, 1, 1 / 3]} data-testid="ProgramVideosList">
            {props.steps()}
          </Box>
        </Flex>
      </Container>
    </div>
  );
};

export default ProgramVideoPlayerLayout;
